import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CallIcon,
  DashboardIcon,
  HistoryIcon,
  MessageIcon,
} from "../../components/icons";
import { NavigationInterface } from "../models";
import {
  BanknotesIcon,
  BookmarkIcon,
  BuildingStorefrontIcon,
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  CircleStackIcon,
  ClipboardDocumentIcon,
  ClipboardDocumentListIcon,
  CurrencyDollarIcon,
  ForwardIcon,
  IdentificationIcon,
  InboxStackIcon,
  MagnifyingGlassCircleIcon,
  MegaphoneIcon,
  PaperClipIcon,
  PencilSquareIcon,
  PhotoIcon,
  PuzzlePieceIcon,
  RectangleGroupIcon,
  RssIcon,
  ShieldExclamationIcon,
  ShoppingCartIcon,
  SignalIcon,
  Squares2X2Icon,
  SquaresPlusIcon,
  TicketIcon,
  TruckIcon,
  UserGroupIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';
import { ArrowUturnUpIcon } from "@heroicons/react/20/solid";
// import { CAMPAGNE_CONTACT } from "../../modules/campagne-module/constants/urls";

const navigationsList: NavigationInterface[] = [
  {
    name: "Expéditions",
    href: "/expeditions",
    icon: TruckIcon,
    children: [
      {
        name: "Moteur de recherche",
        href: "#recherche",
        icon: Squares2X2Icon,
        display: false,
      },
      {
        name: "Tracking",
        href: "#tracking",
        icon: Squares2X2Icon,
      },
      {
        name: "International",
        href: "#envois",
        icon: Squares2X2Icon,
      },
      {
        name: "Livraison Urbaine",
        href: "#livraison-urbaine",
        icon: Squares2X2Icon,
      },
      {
        name: "Voyages",
        href: "#voyages",
        icon: Squares2X2Icon,
        display: false,
      },
      {
        name: "Incidents",
        href: "#incidents",
        icon: Squares2X2Icon,
        display: false,
      },
      {
        name: "Reclamations",
        href: "#reclamations",
        icon: Squares2X2Icon,
      },
      {
        name: "Remboursements",
        href: "#remboursement",
        icon: Squares2X2Icon,
        display: false,
      },
    ],
    color: "purple",
  },
  {
    name: "Conversations",
    href: "/conversations",
    icon: ChatBubbleLeftRightIcon,
    children: [
      {
        name: "Dashboard",
        href: "#dashboard",
        icon: Squares2X2Icon,
      },
      { name: "Messages", href: "#", icon: MessageIcon },

      { name: "Contacts", href: "#contacts", icon: CallIcon, separator: true },
      { name: "Demandes", href: "#demandes", icon: MagnifyingGlassCircleIcon },
      { name: "Incidents", href: "#incidents", icon: ShieldExclamationIcon },
      { name: "Reclamations", href: "#reclamations", icon: SignalIcon },
    ],
    color: "green",
    // separator: true
  },
  {
    name: "Campagnes",
    href: "/campagnes",
    icon: MegaphoneIcon,
    children: [
      {
        name: "Dashboard",
        href: "#",
        icon: Squares2X2Icon,
      },
      {
        name: "Leads",
        href: "#cpg-leads",
        icon: UserGroupIcon,
      },
      {
        name: "Suivi Campagnes",
        href: "#cpg-follow",
        icon: ForwardIcon,
      },
      {
        name: "Creer",
        href: "#cpg-new",
        icon: SquaresPlusIcon,
      },
      {
        name: "Contact",
        href: "#cpg-contact",
        icon: IdentificationIcon,
      },
      {
        name: "Template",
        href: "#cpg-template",
        icon: RectangleGroupIcon,
      },
      {
        name: "Media",
        href: "#cpg-media",
        icon: PhotoIcon,
      },
      {
        name: "CX Flows",
        href: "#cpg-cx",
        icon: PhotoIcon,
      },
    ],
    color: "purple",
  },
  {
    name: "Dashboard",
    href: "/dashboard",
    icon: Squares2X2Icon,
    children: [
      {
        name: "Marketing",
        href: "#",
        icon: BuildingStorefrontIcon,
      },
      {
        name: "Commercial",
        href: "#db-commercial",
        icon: ShoppingCartIcon,
      },
      {
        name: "Operationnel",
        href: "#db-opperationnel",
        icon: PuzzlePieceIcon,
      },
      {
        name: "Satif. Client",
        href: "#db-satisfaction-client",
        icon: UserGroupIcon,
      },
      {
        name: "Chats",
        href: "#db-conversation-chat",
        icon: ChatBubbleLeftRightIcon,
      },
      {
        name: "Finances",
        href: "#db-finances",
        icon: CurrencyDollarIcon,
      },
    ],
    color: "gray",
  },
  {
    name: "CRM CLients",
    href: "/crm-client",
    icon: UsersIcon,
    children: [
      {
        name: "Factures",
        href: "#",
        icon: BanknotesIcon,
        app_type:"YANGZI"
      },
      {
        name: "Commandes Clients",
        href: "#client-commands",
        icon: BookmarkIcon,
        app_type:"YANGZI"
      },
      {
        name: "Stocks",
        href: "#stocks",
        icon: InboxStackIcon,
        app_type:"YANGZI"
      },
      {
        name: "Cotations",
        href: "#quotes",
        icon: PaperClipIcon,
        app_type:"YANGZI"
      },
      {
        name: "Proformats",
        href: "#proforma",
        icon: PencilSquareIcon,
        app_type:"YANGZI",
        separator: true
      },
      {
        name: "Voyages",
        href: "#trips",
        icon: TruckIcon,
        app_type:"PASSENGER"
      },
      {
        name: "Tickets",
        href: "#tickets",
        icon: TicketIcon,
        app_type:"PASSENGER"
      },
      {
        name: "Reservations",
        href: "#reservations",
        icon: ClipboardDocumentIcon,
        app_type:"PASSENGER",
        separator: true
      },
      {
        name: "Expeditions",
        href: "#expeditions",
        icon: TruckIcon,
        app_type:"CLEMENTINO"
      },
      {
        name: "Bordereaux Provisoires",
        href: "#provisional-slips",
        icon: ClipboardDocumentIcon,
        app_type:"CLEMENTINO"
      },
      
      
    ],
    color: "blue",
  },
  {
    name: "Big Data",
    href: "/bigdata",
    icon: CircleStackIcon,
    children: [
      {
        name: "Dashboard",
        href: "#",
        icon: CircleStackIcon,
      },
      {
        name: "Data Analysis",
        href: "#data-analysis",
        icon: CircleStackIcon,
      },
      {
        name: "Data Sources",
        href: "#data-sources",
        icon: CircleStackIcon,
      },
      {
        name: "Data Collector",
        href: "#data-collector",
        icon: CircleStackIcon,
      },
      {
        name: "Data Queries",
        href: "#data-query",
        icon: CircleStackIcon,
      },
    ],
    color: "red",
  },
  {
    name: "Finances",
    href: "/finance",
    icon: CurrencyDollarIcon,
    children: [
      {
        name: "Dashboard",
        href: "#",
        icon: Squares2X2Icon,
      },
      {
        name: "Réconciliation",
        href: "#reconciliation",
        icon: Squares2X2Icon,
      },
      {
        name: "Transactions",
        href: "#transactions",
        icon: Squares2X2Icon,
      },
      {
        name: "États & éditions",
        href: "#etats",
        icon: Squares2X2Icon,
      },
    ],
    color: "brown",
  },
  {
    name: "Reservations",
    href: "/reservations",
    icon: CurrencyDollarIcon,
    children: [
      {
        name: "Moteur de recherche",
        href: "#recherche",
        icon: Squares2X2Icon,
      },
      {
        name: "Reservations",
        href: "#reservations",
        icon: Squares2X2Icon,
      },
      {
        name: "Tickets",
        href: "#tickets",
        icon: Squares2X2Icon,
      },
      {
        name: "Voyages",
        href: "#voyages",
        icon: Squares2X2Icon,
        display: false,
      },
      {
        name: "Incidents",
        href: "#incidents",
        icon: Squares2X2Icon,
        display: false,
      },
      {
        name: "Reclamations",
        href: "#reclamations",
        icon: Squares2X2Icon,
      },
      {
        name: "Remboursements",
        href: "#remboursement",
        icon: Squares2X2Icon,
        display: false,
      },
    ],
    color: "purple",
  },
];

export type AppVersion = "CRM MOPO-V1.0" | "TCCE-V2" | "TCCE-V3";

export const HIDDEN_PATHS_IN_V2 = [
  "/dashboard",
  "/crm-client",
  "/bigdata",
  "/finance",
  "/reservations",
];

// En version TCCE-V3 : uniquement Expéditions, Réservations, Campagnes, Finances (dans cet ordre exact)
export const V3_ORDERED_PATHS = ["/expeditions", "/reservations", "/campagnes", "/finance"];

export const DEFAULT_ASIDE_WIDTH = 220; // ~ w-56
export const MIN_ASIDE_WIDTH = 160;
export const MAX_ASIDE_WIDTH = 480;
export const COLLAPSED_ASIDE_WIDTH = 80; // ~ w-20

interface Props {
  children?: ReactNode;
}

export const LayoutContext = createContext({
  selectChildren: "",
  navigations: [] as NavigationInterface[],
  asideOpen: true,
  asideWidth: DEFAULT_ASIDE_WIDTH,
  setAsideWidth: (width: number) => {},
  appVersion: "TCCE-V3" as AppVersion,
  setAppVersion: (version: AppVersion) => {},
  handleOpenAsude: () => {},
  handleChildren: (value: string) => {},
  isMobile: false,
  mobileSidebarOpen: false,
  setMobileSidebarOpen: (open: boolean) => {},
});

export const LayoutProvider = ({ children }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [asideOpen, setAsideOpen] = useState<boolean>(true);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    return typeof window !== "undefined" ? window.innerWidth < 1024 : false;
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [asideWidth, setAsideWidthState] = useState<number>(() => {
    try {
      const saved = localStorage.getItem("aside_width");
      if (saved) {
        const parsed = parseInt(saved, 10);
        if (!isNaN(parsed) && parsed >= MIN_ASIDE_WIDTH && parsed <= MAX_ASIDE_WIDTH) {
          return parsed;
        }
      }
    } catch (e) {}
    return DEFAULT_ASIDE_WIDTH;
  });

  const setAsideWidth = (width: number) => {
    const clamped = Math.max(MIN_ASIDE_WIDTH, Math.min(MAX_ASIDE_WIDTH, width));
    setAsideWidthState(clamped);
    try {
      localStorage.setItem("aside_width", String(clamped));
    } catch (e) {}
  };

  const [appVersion, setAppVersionState] = useState<AppVersion>(() => {
    const saved = localStorage.getItem("app_version");
    if (saved === "CRM MOPO-V1.0" || saved === "TCCE-V2" || saved === "TCCE-V3") {
      return saved as AppVersion;
    }
    return "TCCE-V3";
  });

  const setAppVersion = (version: AppVersion) => {
    setAppVersionState(version);
    localStorage.setItem("app_version", version);
    if (version === "TCCE-V3") {
      if (!V3_ORDERED_PATHS.includes(location.pathname)) {
        navigate("/expeditions");
      }
    } else if (version === "TCCE-V2" && HIDDEN_PATHS_IN_V2.includes(location.pathname)) {
      navigate("/expeditions");
    }
  };

  const navigations = appVersion === "TCCE-V3"
    ? V3_ORDERED_PATHS.map((path) => navigationsList.find((item) => item.href === path)!).filter(Boolean)
    : appVersion === "TCCE-V2"
    ? navigationsList.filter((item) => !HIDDEN_PATHS_IN_V2.includes(item.href))
    : navigationsList;

  const [selectChildren, setSelectChildren] = useState<string>(
    location.hash
      ? location.hash
      : location.pathname === "/expeditions"
      ? "#tracking"
      : "#"
  );
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (location.pathname === "/expeditions" && (!location.hash || location.hash === "#")) {
      setSelectChildren("#tracking");
    } else if (location.hash) {
      setSelectChildren(location.hash);
    }
  }, [location.pathname, location.hash]);

  useEffect(() => {
    if (!isAuthenticated && location.pathname !== "/") {
      navigate("/");
    }
  }, [isAuthenticated, location.pathname, navigate]);

  useEffect(() => {
    if (!isAuthenticated || location.pathname === "/") return;

    if (appVersion === "TCCE-V3" && !V3_ORDERED_PATHS.includes(location.pathname)) {
      navigate("/expeditions");
    } else if (appVersion === "TCCE-V2" && HIDDEN_PATHS_IN_V2.includes(location.pathname)) {
      navigate("/expeditions");
    }
  }, [appVersion, location.pathname, navigate, isAuthenticated]);

  const handleOpenAsude = () => {
    setAsideOpen(!asideOpen);
  };

  const handleChildren = (value: string) => {
    setSelectChildren(value);
    if (value.startsWith("#")) {
      navigate(`${location.pathname}${value}`);
    } else {
      navigate(value);
    }
  };

  const value = {
    handleOpenAsude,
    asideOpen,
    asideWidth,
    setAsideWidth,
    navigations,
    selectChildren,
    handleChildren,
    appVersion,
    setAppVersion,
    isMobile,
    mobileSidebarOpen,
    setMobileSidebarOpen,
  };
  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
};
export const useLayoutContext = () => useContext(LayoutContext);
